<template>
  <div>
    <Table
      border
      highlight-row
      :loading="tableLoading"
      ref="table"
      :data="table.data"
      :columns="table.columns"></Table>
    <div style="margin: 10px 0; overflow: hidden;">
      <div style="float: left;">
        当前显示 {{ table.data.length }} 条记录，总共 {{ table.count }} 条记录
      </div>
      <div style="float: right;">
        <page
          :total="table.count"
          :current="table.page"
          :page-size="table.size"
          @on-change="getTableData"></page>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'list',
  data () {
    return {
      tableLoading: false,
      table: {
        data: [],
        columns: [],
        count: 1,
        page: 1,
        size: 10
      }
    }
  },
  methods: {
    getTableData () {

    }
  }
}
</script>

<style scoped>

</style>
